import axios from "axios";
import { configRefs } from "@utils/constants";
import { gGateway } from "@utils/gateway";
//#region src/request.get-user-identity.unic.ts
/**
* fetch all data required to describe UniC users according to our internal
* UserModal representation
*/
async function getUnicUserData(userId) {
	var _await$configRefs$api;
	const response = await axios.get(gGateway(`${(_await$configRefs$api = await configRefs.apis.gas.get()) === null || _await$configRefs$api === void 0 ? void 0 : _await$configRefs$api.replaceAll("{{version}}", "v1")}/api/v1/user/UnicUser/${encodeURIComponent(userId)}`));
	const user = {
		id: userId,
		name: `${response.data.FirstName} ${response.data.LastName}`,
		role: mapFunctionDescriptionToUserRole(response.data.FunctionDescription),
		authenticationProvider: "uniLogin"
	};
	if (response.data.InstitutionId && response.data.InstitutionName) {
		user.institution = {
			id: response.data.InstitutionId,
			name: response.data.InstitutionName
		};
		if (user.role === "student") {
			const institutionDetails = await getInstitutionDetailsForStudent(user.id, user.institution.id);
			user.institution.class = institutionDetails.class;
			user.institution.gradeLevel = institutionDetails.gradeLevel;
			if (await isTeacherEducation(user.institution.id)) user.role = "teacher";
		}
	}
	return user;
}
async function getInstitutionDetailsForStudent(userId, institutionId) {
	try {
		var _await$configRefs$api2, _response$data, _response$data2;
		const response = await axios.get(gGateway(`${(_await$configRefs$api2 = await configRefs.apis.gas.get()) === null || _await$configRefs$api2 === void 0 ? void 0 : _await$configRefs$api2.replaceAll("{{version}}", "v1")}/api/v1/Unic/Student/${encodeURIComponent(userId)}/Institution/${encodeURIComponent(institutionId)}`));
		return {
			class: (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.Class) === null || _response$data === void 0 ? void 0 : _response$data.Name,
			gradeLevel: (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.GradeLevel
		};
	} catch {
		return {};
	}
}
async function isTeacherEducation(institutionId) {
	try {
		var _await$configRefs$api3;
		const response = await axios.get(gGateway(`${(_await$configRefs$api3 = await configRefs.apis.gas.get()) === null || _await$configRefs$api3 === void 0 ? void 0 : _await$configRefs$api3.replaceAll("{{version}}", "v1")}/api/v1/unic/Institution/${encodeURIComponent(institutionId)}`));
		return response.data.INST_TYPE_3 === 1085 || response.data.INST_TYPE_3 === "1085";
	} catch {
		return false;
	}
}
/**
* translate FunctionDescription as returned from the Gyldendal Access Service
* into our internal UserRoles representation
*/
function mapFunctionDescriptionToUserRole(functionDescription) {
	if (!functionDescription) return "teacher";
	switch (functionDescription.toLowerCase()) {
		case "elev":
		case "student":
		case "stud":
		case "studerende":
		case "barn": return "student";
		default: return "teacher";
	}
}
//#endregion
export { getUnicUserData, mapFunctionDescriptionToUserRole };

//# sourceMappingURL=request.get-user-identity.unic.js.map